<template>
    <div class="animated fadeIn">
        <b-card>
            <div slot="header">
                {{ this.$route.meta.title }}
                <div class="card-header-actions">
                    <b-button variant="success mr-1" @click="save">Save</b-button>
                    <b-button variant="warning" @click="close">Close</b-button>
                </div>
            </div>
            <simpleFormVue :itemSimpleForm="itemSimpleForm" :$v="$v" :model="model" @clicksearch="search" />
            <b-modal v-model="lkuCoaShow" size="lg" header-bg-variant="danger" :hide-footer="true"
                title="Switch Company" :centered="true">
                <lku-coa @click="onSelectLkuCoa" :tahun="tahun"></lku-coa>
            </b-modal>
        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import simpleFormVue from "../../components/simpleForm.vue";
import lkuCoa from "../lookup/lkuCoa.vue";
toastr.init();

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
    components: { Loading, simpleFormVue, lkuCoa },
    mixins: [validationMixin],
    validations: {
        model: {
            prodcode: { required },
            prodname: { required },
            prodofferingcode: { required },
            prodofferingname: { required },
            prodtype: { required },
            model_pinjaman: { required },
        },
    },
    data() {
        return {
            showFilter: true,
            isLoading: false,
            lkuCoaShow: false,
            searchkey: '',
            tahun: new Date().getFullYear(),
            model: {
                productkey: "",
                prodcode: "",
                prodname: "",
                prodofferingcode: "",
                prodofferingname: "",
                prodtype: "",
                model_pinjaman: "",
                description: "",
                ar_dueNo: "",
                ar_dueNm: "",
                arnot_dueNo: "",
                arnot_dueNm: "",
                UCI_No: "",
                UCI_Nm: "",
                ECI_No: "",
                ECI_Nm: "",
                AR_NA_No: "",
                AR_NA_Nm: "",
                UCI_NA_No: "",
                UCI_NA_Nm: "",
                Beban_diskon_No: "",
                Beban_diskon_Nm: "",
                OTH_INCOME_No: "",
                OTH_INCOME_Nm: "",
                Hutang_Prepaid_PAB_No: "",
                Hutang_Prepaid_PAB_Nm: "",
                latecharge_No: "",
                latecharge_Nm: "",
                pinalty_No: "",
                pinalty_Nm: "",
                Suspend_Account_No: "",
                Suspend_Account_Nm: "",
                Refund_Account_No: "",
                Refund_Account_Nm: "",
                memo_pelunasan_tollerance_days: 0
            },
            itemSimpleForm: {
                prodcode: { type: 'text', col: 6 },
                prodname: { type: 'text', col: 6 },
                prodofferingcode: { type: 'text', col: 6 },
                prodofferingname: { type: 'text', col: 6 },
                prodtype: { type: 'text', col: 6 },
                model_pinjaman: { type: 'text', col: 6 },
                description: { type: 'text', col: 6 },
                memo_pelunasan_tollerance_days: { type: 'text', col: 6 },
                arnot_dueNo: {
                    label:'Disbursement COA Name',
                    type: 'text', col: 6, append: {
                        name: 'search',iconfa:'search'
                    }
                },
                arnot_dueNm: { 
                    label:'Disbursement COA Code',
                    type: 'text', col: 6, disabled: true },
                ar_dueNo: {
                    label:'Repayment COA Name',
                    type: 'text', append: {
                        name: 'search',iconfa:'search'
                    }, col: 6
                },
                ar_dueNm: { 
                    label:'Repayment COA Code',
                    type: 'text', col: 6, disabled: true },
               
                // UCI_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // UCI_Nm: { type: 'text', col: 6, disabled: true },
                // ECI_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // ECI_Nm: { type: 'text', col: 6, disabled: true },
                // AR_NA_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // AR_NA_Nm: { type: 'text', col: 6, disabled: true },
                // UCI_NA_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // UCI_NA_Nm: { type: 'text', col: 6, disabled: true },
                // Beban_diskon_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // Beban_diskon_Nm: { type: 'text', col: 6, disabled: true },
                // OTH_INCOME_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // OTH_INCOME_Nm: { type: 'text', col: 6, disabled: true },
                // Hutang_Prepaid_PAB_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // Hutang_Prepaid_PAB_Nm: { type: 'text', col: 6, disabled: true },
                // latecharge_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // latecharge_Nm: { type: 'text', col: 6, disabled: true },
                // pinalty_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // pinalty_Nm: { type: 'text', col: 6, disabled: true },
                // Suspend_Account_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // Suspend_Account_Nm: { type: 'text', col: 6, disabled: true },
                // Refund_Account_No: {
                //     type: 'text', col: 6, append: {
                //         type: 'search'
                //     }
                // },
                // Refund_Account_Nm: { type: 'text', col: 6, disabled: true },
            }
        };
    },
    computed: {
        invalidModel() {
            this.$v.model.$touch();
            console.log(this.$v.model);
            return this.$v.model.$invalid;
        },
    },
    async created() {

        if (this.$route.params.productkey) {
            try {
                this.isLoading=true;
                const data = await crud.detail({
                    tablename: "finproduct",
                    key: this.$route.params.productkey,
                });
                const row = data;
                for (var key in row) {
                    this.model[key] = row[key];
                }
                this.itemSimpleForm['prodcode'].disabled=true;
                this.isLoading=false;
            } catch (error) {
                this.isLoading=false;
                console.log("error : ", error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
        }
    },
    methods: {
        save: async function () {
            try {
                if (this.invalidModel) {
                    toastr.error("Please fill the form correctly.", "Error Info");
                } else {
                    this.isLoading=true;
                    let data = this.model;
                    if ((this.model.productkey || '') != '') {
                        await crud.update({
                            tablename: "finproduct",
                            key: this.model.productkey,
                            data
                        });
                    } else {
                        await crud.insert({
                            tablename: "finproduct",
                            data
                        });
                    }
                    toastr.success(`Success save PRODUCT.`, "Save Product", 10000);
                    this.isLoading=false;
                    this.close();
                }
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message, "ERROR MESSAGE", 10000);
                } else {
                    toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
                }
            }
        },

        search(val) {
            const { item, key } = val;
            this.searchkey = key;
            this.lkuCoaShow = true;
        },
        onSelectLkuCoa(selected) {
            try {
                const nm = this.searchkey.substring(0,this.searchkey.length-2)+'Nm';
                this.model[this.searchkey] = selected.kodeacc;
                this.model[nm] = selected.namaacc;

                this.lkuCoaShow = false;
            } catch (error) {
                this.lkuCoaShow = false;
                if (error.message) {
                    toastr.error(error.message, "ERROR MESSAGE", 10000);
                } else {
                    toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
                }
            }
        },
        close() {
            router.push({ name: "admin.product" });
        },
    },
};
</script>